import React from "react";
import LogoAura from "../LogoAura";

const LOGO_SRC = "/assets/logo.png";

const HeroLogo = () => (
  <div className="flex justify-center mb-10 animate-fade-in-up">
    <div className="parallax-layer relative" style={{ "--depth": "30px" }}>
      <div className="logo-inner-bloom" aria-hidden />
      <LogoAura size={224} />
      <img
        src={LOGO_SRC}
        alt="Authentic Momentum"
        data-testid="hero-logo"
        className="relative w-44 h-44 md:w-56 md:h-56 object-contain logo-mask animate-breathe-premium"
        draggable="false"
        style={{ zIndex: 2 }}
      />
    </div>
  </div>
);

export default HeroLogo;
